import { LOCAL_STORAGE_KEYS } from '../../utils/constants'
import { apiHeaders } from '../../utils/utils'
import { axiosRMSWrapper } from '../helpers/api'
import { EMethods, RMSRequestUrl } from '../helpers/requests'

export interface DynamicFormSubmission {
  oms_order_id: string
  type: string
  data: Record<string, any>
}

export const submitDynamicForm = (payload: DynamicFormSubmission) =>
  axiosRMSWrapper({
    method: EMethods.post,
    url: RMSRequestUrl.customReturn,
    headers: {
      'Content-Type': 'application/json',
      ...apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)),
    },
    data: payload,
  })

export interface SignedUrlParams {
  fileName: string
  fileType: string
  entityType: string
}

export const getFileSignedUrl = (params: SignedUrlParams) =>
  axiosRMSWrapper({
    method: EMethods.post,
    url: RMSRequestUrl.fileSignedUrl,
    data: {
      name: params.fileName,
      type: params.fileType,
      entityType: params.entityType,
    },
  })

export const deleteFile = (fileId: string) =>
  axiosRMSWrapper({
    method: EMethods.delete,
    url: RMSRequestUrl.file,
    uid: fileId,
  })
